// OmniSound landing: the licence key is made BEFORE checkout and travels with the order (cart attributes),
// together with the device that opened the page from the app (?k=tv|pc|android&d=XXXX-XXXX).
(function () {
  var A = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
  function newKey() {
    var b = new Uint8Array(12), s = "";
    crypto.getRandomValues(b);
    for (var i = 0; i < 12; i++) s += A[b[i] % 32];
    return "OMNI-" + s.slice(0, 4) + "-" + s.slice(4, 8) + "-" + s.slice(8, 12);
  }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function init() {
    var keyEl = document.getElementById("om-key");
    if (!keyEl) return;
    var q = new URLSearchParams(location.search);
    var kind = q.get("k"), dev = (q.get("d") || "").toUpperCase();
    if (["tv", "pc", "android"].indexOf(kind) >= 0 && /^[0-9A-Z]{4}-[0-9A-Z]{4}$/.test(dev)) { store("om.kind", kind); store("om.dev", dev); }
    kind = store("om.kind"); dev = store("om.dev");
    var T = window.OM_TXT || {};
    var forEl = document.getElementById("om-for");
    if (kind && dev && forEl && T["for_" + kind]) { forEl.textContent = T["for_" + kind].replace("%CODE%", dev); forEl.hidden = false; }
    var key = store("om.key");
    if (!key) { key = newKey(); store("om.key", key); }
    keyEl.textContent = key;
    document.querySelectorAll("[data-om-buy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-om-buy");
        if (!v) { document.getElementById("om-soon").textContent = T.soon || ""; return; }
        var p = new URLSearchParams();
        p.set("attributes[Licence]", key);
        if (kind && dev) p.set("attributes[Device]", dev);
        location.href = "/cart/" + v + ":1?" + p.toString();
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
